<!--抄表管理信息列表水表-->
<template>
  <div class="warmetermanagerlist">
    <div class="con">
      <div class="search-input-btn" style="width:100%">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-i">
            <div class="input-small mr-20">
              <span>设备编号：</span>
              <el-input
                v-model="deviceNo"
                placeholder="请输入设备编号"
                style="width:120px"
              ></el-input>
            </div>
            <div class="input-small mr-20">
              <span>设备名：</span>
              <el-input
                v-model="findDeviceName"
                placeholder="请输入设备名"
                style="width:110px"
              ></el-input>
            </div>
            <div class="input-small mr-20">
              <span>业主姓名：</span>
              <el-input
                v-model="ownerName"
                placeholder="请输入业主姓名"
                style="width:110px"
              ></el-input>
            </div>
            <div class="input-small mr-20 myinput-mill">
              <span>抄表日期：</span>
              <el-select
                v-model="DateDay"
                clearable
                placeholder="请选择"
                @change="selectDeductionFeeDay"
                style="width:87px"
              >
                <el-option
                  v-for="item in getDateDay"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="input-small mr-20 myinput-mill">
              <span>开合闸状态：</span>
              <el-select
                v-model="deviceStatus"
                clearable
                placeholder="请选择"
                @change="selectDeviceState232"
                style="width:90px"
              >
                <el-option
                  v-for="item in deviceStatusList"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="input-small mr-20 myinput-mill">
              <span>开户状态：</span>
              <el-select
                v-model="relevanceStatus"
                clearable
                placeholder="请选择"
                @change="selectRelevanceState"
                style="width:90px"
              >
                <el-option
                  v-for="item in relevanceStatusList"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="input-small myinput-mill">
              <span>联网状态：</span>
              <el-select
                v-model="connectStatus"
                clearable
                placeholder="请选择"
                @change="selectDeviceState"
                style="width:90px"
              >
                <el-option
                  v-for="item in connectStatusList"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <el-button
              type="primary"
              plain
              @click="getDataList"
              class="search-btn"
              >查询</el-button
            >
            <el-button type="primary" @click="addMeterSet" class="search-btn"
              >新增</el-button
            >
            <el-button type="primary" @click="exportReport" class="search-btn"
              >导出</el-button
            >
          </div>
        </el-scrollbar>
      </div>
      <div class="mytable" :style="{ height: heights + 'px' }">
        <el-table
          :data="dataList"
          :max-height="heights - 20"
          border
          style="width: 100%;"
        >
          <template slot="empty">
            <span class="noData">
              <img src="../../../assets/noData.png" alt="暂无数据" />
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column
            type="index"
            width="50"
            fixed
            label="序号"
            align="center"
          >
          </el-table-column>
          <el-table-column fixed prop="deviceName" width="180" label="设备名称">
          </el-table-column>
          <el-table-column prop="deviceNo" label="设备编号" width="80">
          </el-table-column>
          <el-table-column prop="userName" label="业主姓名" width="100">
          </el-table-column>
          <el-table-column prop="deductionFeeDay" label="抄表日期" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.deductionFeeDay }}号</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="realElectricQuantity"
            label="实时用水量(m³)"
            width="130"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.realElectricQuantity }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="realAmount" label="实时水费(元)" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.realAmount / 100 }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="amount" label="上月用水量(m³)" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.electricQuantity }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="amount" label="上月水费(元)" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.amount / 100 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="state" label="是否开户" width="100">
            <template slot-scope="scope">
              <span class="wrongStatus" v-show="scope.row.state == 0"
                >未开户</span
              >
              <span class="wrongStatus" v-show="scope.row.state == -1"
                >欠费中</span
              >
              <span
                class="normalStatus"
                v-show="scope.row.state == undefined || scope.row.state == null"
                >-</span
              >
              <span class="normalStatus" v-show="scope.row.state == 1"
                >已开户</span
              >
            </template>
          </el-table-column>

          <el-table-column prop="deviceState" label="联网状态" width="100">
            <template slot-scope="scope">
              <span class="normalStatus" v-show="scope.row.deviceState == 1"
                >在线</span
              >
              <span class="wrongStatus" v-show="scope.row.deviceState != 1"
                >离线</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="state232" label="开合闸状态" width="100">
            <template slot-scope="scope">
              <img :src="getDeviceStateSource(scope.row.state232)" alt="" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="viewDetails(scope.row)"
                plain
                >表管理</el-button
              >
              <el-button
                size="mini"
                type="primary"
                v-if="scope.row.state232 != 0"
                @click="onOffState(scope.row, 0)"
                plain
                >开</el-button
              >
              <el-button
                size="mini"
                type="danger"
                v-else
                @click="onOffState(scope.row, 1)"
                plain
                >关</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="deleteMeter(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="show-table" v-show="false" id="region-cost">
        <el-table :data="dataList" border style="width: 100%">
          <el-table-column prop="deviceName" label="设备名称" width="165">
          </el-table-column>
          <el-table-column
            prop="deviceNo"
            align="center"
            label="设备编号"
            width="165"
          >
          </el-table-column>
          <el-table-column
            prop="deductionFeeDay"
            align="center"
            label="抄表时间"
            width="165"
          >
          </el-table-column>
          <el-table-column prop="electricQuantity" label="用水量" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.electricQuantity }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="水费" width="100">
            <template slot-scope="scope">
              <span>{{ (scope.row.amount / 100).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            align="center"
            label="户主名称"
            width="165"
          >
          </el-table-column>
          <el-table-column
            prop="state"
            label="是否开户"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.state == 0">未开户</span>
              <span v-if="scope.row.state == -1">欠费中</span>
              <span
                v-if="scope.row.state == undefined || scope.row.state == null"
                >-</span
              >
              <span v-if="scope.row.state == 1">已开户</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="deviceState"
            label="联网"
            width="70"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.deviceState == 1">在线</span>
              <span v-else>离线</span>
            </template>
          </el-table-column>
          <el-table-column prop="state232" label="开合闸状态" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.state232 == 0">断开</span>
              <span v-else>合闸</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="divider-line"></div>
      <elPagination
        :total="totalSize"
        :pageSize="pageSize"
        @pageindexChange="jumpToPage"
        @handleSizeChange="pageSizeChange"
      />
      <downloadTable ref="downloadTable"></downloadTable>
    </div>
    <VerifyPasswordDialog ref="verifyPasswordDialog"></VerifyPasswordDialog>
    <AddNewMeterDialog
      ref="addNewWaterMeterDialog"
      @successList="successList"
    ></AddNewMeterDialog>
    <SelectChargeModeDialog
      ref="selectChargeModeDialog"
    ></SelectChargeModeDialog>
  </div>
</template>

<script>
import datePicker from "@/components/module/universal/datePicker.vue";
import infoListMultipleSelection from "@/page/system/meterReading/infoListMultipleSelection.vue";
import singleSelection from "@/components/module/selection/singleSelection.vue";
import VerifyPasswordDialog from "./dialogs/VerifyPasswordDialog.vue";
import AddNewMeterDialog from "./dialogs/AddNewMeterDialog.vue";
import SelectChargeModeDialog from "./dialogs/SelectChargeModeDialog.vue";
import meterManagerStore from "./meterManagerStore.js";
import elPagination from "@/components/module/elComponents/elPagination.vue";
import downloadTable from "@/components/module/downloadTable/downloadTable.vue";
import request from "@/api/http.js";
export default {
  components: {
    datePicker,
    elPagination,
    infoListMultipleSelection,
    VerifyPasswordDialog,
    AddNewMeterDialog,
    SelectChargeModeDialog,
    singleSelection,
    downloadTable,
  },
  props: {},
  data() {
    return {
      heights: Math.round(document.getElementById("app").clientHeight * 0.75),
      loading: false,
      pageIndex: 1,
      pageSize: 20,
      totalSize: 0,
      dataList: [
        {
          amountOfArrears: null,
          freeQuota: 0.0,
          meterReadingStatus: "DISABLE",
          maxEndElectric: null,
          deductionStandard: "5",
          deviceName: "气元一4033厂房",
          lastDeductionFeeTime: null,
          balance: 1002,
          entityName: "MeterReadingConfig",
          id: "16",
          meterRunType: 1,
          state: 1,
          minBeginTime: null,
          useElectric: 0.0,
          accountType: "0",
          userBingdingTime: 1698283758000,
          balanceAlarm: 99999.0,
          deviceNo: 16,
          electricQuantity: 1212,
          generallyName: "气元一4033厂房",
          surplusQuota: null,
          isAutomaticBrake: 1,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 241818436872193,
          realAmount: 1123,
          meterReadingStartTime: null,
          deductionFeeDay: 1,
          sn: "",
          basicElectricityCharges: 0.0,
          amount: 23423,
          cardType: null,
          maxEndTime: null,
          minBeginMeterReading: null,
          userName: "999",
          userBalanceSum: 0.0,
          conversionRate: null,
          userId: "18fd6233de6544a6af47056c9ee251df",
          state232: null,
          realElectricQuantity: 122,
          createTime: 1677147329000,
          meterType: "water",
          maxEndMeterReading: null,
          realDeductionFeeTime: null,
          minStartElectric: null,
        },
        {
          amountOfArrears: null,
          freeQuota: 0.0,
          meterReadingStatus: "DISABLE",
          maxEndElectric: null,
          deductionStandard: "5",
          deviceName: "英派尔预付费表",
          lastDeductionFeeTime: null,
          balance: 1002,
          entityName: "MeterReadingConfig",
          id: "19",
          meterRunType: 1,
          state: 1,
          minBeginTime: null,
          useElectric: 0.0,
          accountType: "0",
          userBingdingTime: 1698283758000,
          balanceAlarm: 99999.0,
          deviceNo: 19,
          electricQuantity: 1123,
          generallyName: "英派尔预付费表",
          surplusQuota: null,
          isAutomaticBrake: 1,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 241818436872193,
          realAmount: 1223,
          meterReadingStartTime: null,
          deductionFeeDay: 1,
          sn: "",
          basicElectricityCharges: 0.0,
          amount: 23432,
          cardType: null,
          maxEndTime: null,
          minBeginMeterReading: null,
          userName: "999",
          userBalanceSum: 0.0,
          conversionRate: null,
          userId: "18fd6233de6544a6af47056c9ee251df",
          state232: 0,
          realElectricQuantity: 221,
          createTime: 1677147281000,
          meterType: "water",
          maxEndMeterReading: null,
          realDeductionFeeTime: null,
          minStartElectric: null,
        },
        {
          amountOfArrears: null,
          freeQuota: 0.0,
          meterReadingStatus: "DISABLE",
          maxEndElectric: 7.0,
          deductionStandard: "5",
          deviceName: "水表",
          lastDeductionFeeTime: 1685548800000,
          balance: 1002,
          entityName: "MeterReadingConfig",
          id: "20",
          meterRunType: 1,
          state: 1,
          minBeginTime: 1671667200000,
          useElectric: 7.0,
          accountType: "0",
          userBingdingTime: 1698283758000,
          balanceAlarm: 99999.0,
          deviceNo: 20,
          electricQuantity: 1322,
          generallyName: "水表",
          surplusQuota: 0.0,
          isAutomaticBrake: 1,
          deviceState: 0,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 241818436872193,
          realAmount: 2113,
          meterReadingStartTime: null,
          deductionFeeDay: 1,
          sn: "",
          basicElectricityCharges: 0.0,
          amount: 23421,
          cardType: null,
          maxEndTime: 1685548800000,
          minBeginMeterReading: 4232.0,
          userName: "999",
          userBalanceSum: 9900.0,
          conversionRate: null,
          userId: "18fd6233de6544a6af47056c9ee251df",
          state232: 0,
          realElectricQuantity: 321,
          createTime: 1670980545000,
          meterType: "water",
          maxEndMeterReading: 6041.0,
          realDeductionFeeTime: null,
          minStartElectric: 0.0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0.0,
          meterReadingStatus: "DISABLE",
          maxEndElectric: null,
          deductionStandard: "5",
          deviceName: "3号晔燃水表",
          lastDeductionFeeTime: null,
          balance: null,
          entityName: "MeterReadingConfig",
          id: "26",
          meterRunType: 2,
          state: 1,
          minBeginTime: null,
          useElectric: 0.0,
          accountType: "1",
          userBingdingTime: 1698283758000,
          balanceAlarm: null,
          deviceNo: 27,
          electricQuantity: 2234,
          generallyName: "3号晔燃水表",
          surplusQuota: null,
          isAutomaticBrake: null,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 241818436872193,
          realAmount: 3323,
          meterReadingStartTime: null,
          deductionFeeDay: 1,
          sn: "",
          basicElectricityCharges: 0.0,
          amount: 23423,
          cardType: null,
          maxEndTime: null,
          minBeginMeterReading: null,
          userName: 1,
          userBalanceSum: 0.0,
          conversionRate: null,
          userId: null,
          state232: null,
          realElectricQuantity: 432,
          createTime: 1685086398000,
          meterType: "water",
          maxEndMeterReading: null,
          realDeductionFeeTime: null,
          minStartElectric: null,
        },
        {
          amountOfArrears: null,
          freeQuota: 0.0,
          meterReadingStatus: "DISABLE",
          maxEndElectric: null,
          deductionStandard: "5",
          deviceName: "2号晔燃水表",
          lastDeductionFeeTime: null,
          balance: null,
          entityName: "MeterReadingConfig",
          id: "26",
          meterRunType: 2,
          state: 1,
          minBeginTime: null,
          useElectric: 0.0,
          accountType: "1",
          userBingdingTime: 1698283758000,
          balanceAlarm: null,
          deviceNo: 28,
          electricQuantity: 3424,
          generallyName: "2号晔燃水表",
          surplusQuota: null,
          isAutomaticBrake: null,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 241818436872193,
          realAmount: 2213,
          meterReadingStartTime: null,
          deductionFeeDay: 1,
          sn: "",
          basicElectricityCharges: 0.0,
          amount: 1233,
          cardType: null,
          maxEndTime: null,
          minBeginMeterReading: null,
          userName: 1,
          userBalanceSum: 0.0,
          conversionRate: null,
          userId: null,
          state232: null,
          realElectricQuantity: 213,
          createTime: 1685086398000,
          meterType: "water",
          maxEndMeterReading: null,
          realDeductionFeeTime: null,
          minStartElectric: null,
        },
        {
          amountOfArrears: null,
          freeQuota: 0.0,
          meterReadingStatus: "DISABLE",
          maxEndElectric: null,
          deductionStandard: "5",
          deviceName: "1号晔燃水表",
          lastDeductionFeeTime: null,
          balance: null,
          entityName: "MeterReadingConfig",
          id: "26",
          meterRunType: 2,
          state: 1,
          minBeginTime: null,
          useElectric: 0.0,
          accountType: "1",
          userBingdingTime: 1698283758000,
          balanceAlarm: null,
          deviceNo: 29,
          electricQuantity: 1231,
          generallyName: "1号晔燃水表",
          surplusQuota: null,
          isAutomaticBrake: null,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 241818436872193,
          realAmount: 4221,
          meterReadingStartTime: null,
          deductionFeeDay: 1,
          sn: "",
          basicElectricityCharges: 0.0,
          amount: 12312,
          cardType: null,
          maxEndTime: null,
          minBeginMeterReading: null,
          userName: 1,
          userBalanceSum: 0.0,
          conversionRate: null,
          userId: null,
          state232: null,
          realElectricQuantity: 132,
          createTime: 1685086398000,
          meterType: "water",
          maxEndMeterReading: null,
          realDeductionFeeTime: null,
          minStartElectric: null,
        },
      ],
      deviceNo: "",
      findDeviceName: "",
      deviceName: "",
      ownerName: "",
      state: undefined,
      state232: undefined,
      deviceState: undefined,
      filterTime: false,
      searchChange: false,
      deductionFeeDay: "",
      meterType: "water",
      DateDay: "",
      deviceStatus: "",
      relevanceStatus: "",
      connectStatus: "",
    };
  },
  mounted() {
    this.getDataList();
    meterManagerStore.commit("getAllMeterBillingMode", this.nowUnit.id);
  },
  computed: {
    getDateDay() {
      // console.log("日期",this.dateDay());
      return this.dateDay();
    },
    nowUser() {
      return this.$store.userStore.state.nowUserInfo;
    },
    nowUnit() {
      return this.$store.unitStore.state.nowUnit;
    },
    nowSelectDate() {
      return this.$store.cacheStore.getters.getNowSelectDate;
    },
    nowTimeInterval() {
      return this.$store.cacheStore.getters.getMeterTimeInterval;
    },
    nowDateText() {
      return this.filterTime
        ? this.nowTimeInterval.startDate.formatByDate() +
            " - " +
            this.nowTimeInterval.endDate.formatByDate()
        : "";
    },
    columns() {
      return meterManagerStore.state.columns;
    },
    editOwnerName() {
      return (ownername) => {
        return ownername == null || ownername == "" || ownername == undefined
          ? "-"
          : ownername;
      };
    },
    chargingStatusList() {
      return meterManagerStore.state.chargingStatusList;
    },
    deviceStatusList() {
      return meterManagerStore.state.deviceStatusList;
    },
    deviceStatusList() {
      return [
        { text: "请选择", value: "" },
        { text: "开闸", value: 0 },
        { text: "合闸", value: 1 },
      ];
    },
    relevanceStatusList() {
      return [
        { text: "请选择", value: "" },
        { text: "未开户", value: 0 },
        { text: "已开户", value: 1 },
      ];
    },
    connectStatusList() {
      return [
        { text: "请选择", value: "" },
        { text: "离线", value: 0 },
        { text: "在线", value: 1 },
      ];
    },
    timeText() {
      return (time) => {
        if (time == null || time == undefined || time == "") {
          return "-";
        }
        return new Date(time).formatByDate();
      };
    },
    getDeviceStateSource() {
      return (state) => {
        if (parseInt(state) == 0) {
          return this.$store.resourcesStore.getters.getResourcesByName(
            "keli/state_on.png"
          );
        } else if (parseInt(state) != 0) {
          return this.$store.resourcesStore.getters.getResourcesByName(
            "keli/state_off.png"
          );
        }
        //return this.$store.resourcesStore.getters.getResourcesByName('keli/state_no.png')
      };
    },
  },
  watch: {
    nowUser(nv, ov) {
      meterManagerStore.commit("setNowUser", nv);
    },
    nowUnit(nv, ov) {
      meterManagerStore.commit("setNowUnit", this.nv);
      this.getDataList(nv);
      meterManagerStore.commit(
        "getAllMeterBillingMode",
        this.nowUnit.id,
        "second"
      );
    },
    deviceNo(nv, ov) {
      this.searchChange = true;
    },
    ownerName(nv, ov) {
      this.searchChange = true;
    },
    state(nv, ov) {
      this.searchChange = true;
    },
    deviceState(nv, ov) {
      this.searchChange = true;
    },
    state232(nv, ov) {
      this.searchChange = true;
    },
    filterTime(nv, ov) {
      this.searchChange = true;
    },
    nowTimeInterval(nv, ov) {
      this.searchChange = true;
    },
  },
  methods: {
    pageindexChange() {},
    // 分页
    handleSizeChange() {},
    dateDay() {
      let list = [];
      for (let i = 0; i < 32; i++) {
        let obj = {
          text: i + "号",
          value: i,
        };

        if (i == 0) {
          obj = {
            text: "请选择",
            value: "",
          };
        }

        list.push(obj);
      }
      return list;
    },
    selectDeviceState232(item) {
      // this.state232 = item.value
      this.state232 = item;
    },
    selectDeductionFeeDay(item) {
      // this.deductionFeeDay = item.value
      this.deductionFeeDay = item;
    },
    selectRelevanceState(item) {
      // this.state = item.value
      this.state = item;
    },
    selectDeviceState(item) {
      // this.deviceState = item.value
      this.deviceState = item;
    },
    // 操作水表开关
    onOffState(item, state) {
      if (item.deviceState != 1) {
        return;
      }
      //var state = parseInt(item.state232) == 1 ? 1 : 0
      this.$refs.verifyPasswordDialog.open("密码验证", (password) => {
        this.$api.meterReadingApi.controlMeter(
          item.userId,
          item.deviceNo,
          state,
          password,
          (respon) => {
            this.$set(item, "state232", state);
            this.$dialogMethod.showMessage("操作成功");
          },
          (err) => {
            this.$dialogMethod.showMessage(err);
          }
        );
      });
    },
    viewDetails(item) {
      meterManagerStore.commit("setDeviceInfo", item);
      this.$emit("viewDetails", item);
    },
    // 删除水表
    deleteMeter(item) {
      this.$dialogMethod.openAgreeDialog(
        "提示",
        "确认删除设备名称：" +
          item.deviceName +
          " 设备编号：" +
          item.deviceNo +
          " 的水表配置？",
        (confirm) => {
          this.$api.meterReadingApi.removeMeterReadingConfig(
            item.deviceNo,
            (respon) => {
              this.$dialogMethod.showMessage(respon);
              meterManagerStore.commit(
                "getMeterReadingConfigList",
                this.nowUnit.id
              );
              this.getDataList();
            },
            (err) => {
              this.$dialogMethod.showMessage(err);
            }
          );
        },
        (cancel) => {
          return;
        },
        true
      );
    },
    successList() {
      this.getDataList();
    },
    // 获取抄表列表信息
    getDataList() {
      //debugger
      if (isempty(this.nowUnit)) {
        return;
      }
      if (this.searchChange) {
        this.pageIndex = 1;
        this.$refs.meterManagerList.pageIndex = 1;
        this.searchChange = false;
      }
      //var beginTime = this.filterTime ? this.nowTimeInterval.startDate.getTime() : undefined
      //var endTime = this.filterTime ? this.nowTimeInterval.endDate.getTime() : undefined
      // this.$api.meterReadingApi.getUnitMeterReadingConfigLimit(this.nowUnit.id, this.pageIndex, this.pageSize, this.deviceNo, this.ownerName, this.state, this.state232, this.deviceState, beginTime, endTime, respon => {
      // 	console.info(23424);
      // 	this.dataList = copy(respon.dataList.sort(this.compare('deviceName')))
      // 	this.totalSize = respon.total
      // 	this.$refs.meterManagerList.totalSize = respon.total
      // })
      //debugger
      this.$api.meterReadingApi.getUnitMeterReadingConfigLimit(
        this.nowUnit.id,
        this.pageIndex,
        this.pageSize,
        this.deviceNo,
        this.findDeviceName,
        this.ownerName,
        this.state,
        this.state232,
        this.deviceState,
        this.deductionFeeDay,
        this.meterType,
        (respon) => {
          //console.info(999);
          this.dataList = copy(
            respon.dataList.sort(this.compare("deviceName"))
          );
          this.totalSize = respon.total;

          //查询条件清空
          this.emptySerParam();
        }
      );
    },

    emptySerParam() {
      this.deviceNo = "";
      this.ownerName = "";
      //this.dateDay();
      //this.state = 0;
      //this.deviceState = 0;
    },

    compare(name) {
      return function(a, b) {
        //debugger
        var s1 = a[name];
        var s2 = b[name];
        return s1.localeCompare(s2);
      };
    },

    // 添加水表配置
    addMeterSet() {
      this.$refs.addNewWaterMeterDialog.dialogFormVisible = true;
    },
    // 导出报表
    exportReport() {
      // if(isempty(this.deductionFeeDay)) {
      //   this.$dialogMethod.showMessage('请选择抄表日期！')
      //   return
      // }
      var title = this.nowUnit.name + "水表信息";

      // var params={
      //   unitid: this.nowUnit.id,
      //   meterRunType: this.meterRunType,
      //   deviceNo: this.deviceNo,
      //   ownerName: this.ownerName,
      //   deductionFeeDay: this.deductionFeeDay,
      //   accountType: this.accountType,
      //   meterType: this.meterType
      // }
      const tHeader = [title];
      this.$refs.downloadTable.export2Excel(
        tHeader,
        this.dataList,
        title,
        "#region-cost"
      );

      // Get请求
      // request({url: "/meterReading/exportUnitWaterMeterReadingConfig.do",method: "get",params}).then(res => {
      //   console.log(res,'res');
      //   saveAs(DWSystemSetting.downloadUrl+'/'+res.data,title+".xls")
      // })

      // this.$api.meterReadingApi.exportUnitMeterReadingConfig(this.nowUnit.id,this.deviceNo,this.ownerName,this.state,this.deductionFeeDay,' ',this.meterType,respon => {
      //   saveAs(DWSystemSetting.downloadUrl+'/'+respon,title+".xls")
      // })
    },
    // 切换每页显示条数
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
      this.getDataList();
    },
    // 切换页码
    jumpToPage(pageIndex) {
      this.pageIndex = pageIndex;
      this.getDataList();
    },
    // 选择时间区间的事件
    selectTimeInterval(timeInterval) {
      this.$store.cacheStore.commit("setMeterTimeInterval", timeInterval);
      this.$refs.datePicker.hide();
      this.filterTime = true;
    },
  },
};
</script>

<style scoped lang="scss">
.warmetermanagerlist {
  width: 100%;
  height: 100%;

  .con {
    width: 100%;
    height: 100%;
    padding: 2px 20px 12px 20px;
    background-color: #fff;
    box-sizing: border-box;

    .myinput-mill {
      /deep/.el-input__inner {
        width: 90px;
      }

      /deep/.el-input {
        width: 90px !important;
      }
    }
  }
}
</style>
